import * as roles from '../actionTypes/Roles/Roles'
import Api from '../Api'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'
import AuthenticationService from '../components/Security/AuthenticationService'
const _ = require('underscore')

function getRolesSuccess (rolesDetails) {
  return {
    type: roles.GET_ROLES,
    rolesDetails: rolesDetails
  }
}

export const getRoles = (callBack) => {
  const authService = new AuthenticationService(Config.authBaseUrl)
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getRolesList + '?uuid=' + authService.getUUID() + '&isAdmin=' + (authService.isAdmin() ? '1' : '0')
  return (dispatch, getState) => {
    const api = new Api()
    api.getData(url, data => {
      let rolesData = data
      dispatch(getRolesSuccess(rolesData))
      callBack()
    })
  }
}

function getPermissionSuccess (userPermission) {
  return {
    type: roles.GET_PERMISSIONS,
    userPermission: userPermission
  }
}

export const getPermission = () => {
  const authService = new AuthenticationService(Config.authBaseUrl)
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getPermissions
  if (authService.getUUID()) {
    url += '?uuid=' + authService.getUUID()
  }
  return (dispatch, getState) => {
    const api = new Api()
    api.getData(url, data => {
      let permissions = _.pluck(data.data[0], 'Permission_Name')
      new AuthenticationService(Config.authBaseUrl).authService.setPermission(permissions)
      dispatch(getPermissionSuccess(permissions))
    })
  }
}

export const refreshPermission = () => {
  window.localStorage.removeItem('user_perm')
}

function getPermissionsListSuccess (permissionList) {
  return {
    type: roles.GET_PERMISSIONS_LIST,
    permissionList: permissionList
  }
}

export const getPermissionsList = (callBack) => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getPermissionsList
  return (dispatch, getState) => {
    const api = new Api()
    api.getData(url, result => {
      let permissionList = result.data
      dispatch(getPermissionsListSuccess(permissionList))
      callBack()
    })
  }
}
function getRoledetailsSuccess (getRoleinfo) {
  return {
    type: roles.GET_ROLE_INFORMATION,
    getRoleinfo: getRoleinfo
  }
}

export const getRoledetails = (roleUID, callBack) => {
  return (dispatch, getState) => {
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.getRoleById + '?roleUid=' + roleUID
    const api = new Api()
    api.getData(url, result => {
      let getRoleinfo = result.data
      dispatch(getRoledetailsSuccess(getRoleinfo))
      callBack()
    })
  }
}

function getAccountSuccess (IsOwner) {
  return {
    type: roles.GET_ROLES_USERINFO,
    IsOwner: IsOwner
  }
}

export const getAccountInfo = (callBack) => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getAccountInfo
  return (dispatch, getState) => {
    const api = new Api()
    api.getData(url, data => {
      let IsOwner = data.IsOwner
      dispatch(getAccountSuccess(IsOwner))
      callBack()
    })
  }
}

export const rolesAndPermissions = (roleID) => {
  return dispatch => Promise.resolve(dispatch(getPermissionsList()))
    .then((response) => {
      Promise.resolve(dispatch(getRoledetails(roleID)))
        .then((result) => {
          Promise.resolve(dispatch(getPermission()))
            .catch(error => console.log(error))
        }).catch(error => console.log(error))
    }).catch(error => console.log(error))
}



// WEBPACK FOOTER //
// ./src/actions/roles.js